import React from "react";
import { useLocation } from "react-router-dom";
import Footer from "../sections/Footer";
import PolicyPage from "../sections/PolicyPageEN";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
import { getOrganizationSchema, getBreadcrumbSchema } from "../utils/structuredData";

export default function Policy() {
    const location = useLocation();
    const baseUrl = process.env.REACT_APP_BASE_URL || 'https://livespainvisa.com';
    const currentUrl = `${baseUrl}${location.pathname}`;

    const seoData = {
        title: "Privacy Policy - Live Spain Visa | Legal Services",
        description: "Privacy Policy for Live Spain Visa Consulting. Learn how we collect, use, and protect your personal information when you use our immigration and visa services.",
        keywords: "privacy policy, data protection, GDPR, Live Spain Visa privacy"
    };

    const breadcrumbSchema = getBreadcrumbSchema([
        { name: 'Home', url: baseUrl },
        { name: 'Privacy Policy', url: currentUrl }
    ]);

    return (
        <>
            <SEO
                title={seoData.title}
                description={seoData.description}
                keywords={seoData.keywords}
                canonicalUrl={currentUrl}
                ogImage={`${baseUrl}/og-image.jpg`}
                lang="en"
                alternateLanguages={[
                    { lang: 'en', url: `${baseUrl}/policyEN/` },
                    { lang: 'es', url: `${baseUrl}/policyES/` }
                ]}
            />
            <StructuredData data={getOrganizationSchema()} id="organization-schema-policy" />
            <StructuredData data={breadcrumbSchema} id="breadcrumb-schema-policy" />
            <div>
                <PolicyPage/>
                <Footer/>
            </div>
        </>
    )
}
